import React from 'react';
import { Alert } from 'reactstrap';
import ReportsListRow from './ReportsListRow';
import './ReportListTable.css';

const ReportListTable = ({ reports, onBoxClick,user }) => {
  const sortedReports = [...reports].sort((a, b) => {
    const nameA = a?.reportName || '';
    const nameB = b?.reportName || '';
    const startsWithNumberA = /^\d/.test(nameA);
    const startsWithNumberB = /^\d/.test(nameB);
    if (startsWithNumberA && !startsWithNumberB) return 1;
    if (!startsWithNumberA && startsWithNumberB) return -1;
    return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
  });

  return (
    <div className="table-header-fixed">
      <table className="provisionList">
        <thead>
          <tr>
            <th className="cursor-pointer">Reports</th>
            <th>Owner</th>
            {user.permissionsGroup !== "Customer" && (
              <th className="cursor-pointer">Audience</th>
            )}
          </tr>
        </thead>
        <tbody>
          {sortedReports.length ? (
            sortedReports.map((report, i) => (
              <ReportsListRow report={report} key={i} onBoxClick={onBoxClick} />
            ))
          ) : (
            <tr>
              <td colSpan={10}>
                <Alert rowSpan={10} color="info">
                  No Reports for found.
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReportListTable;
